module.exports = __webpack_public_path__ + "img/tech-icon-1@2x.100de3d3.png";